/**
 * @module root/components/accreditation
 */
import * as STATES                  from './accreditation.states';
import { AUDIT_MODULE }             from './audit/audit.module';
import { REQUIREMENTS_ASSESSMENT_MODULE } from './requirements-assessment/requirements-assessment.module';
import { SETTINGS_MODULE }          from './settings/settings.module';
import { TASKS_MODULE }             from './tasks/tasks.module';
import { ADD_DOCUMENT_MODULE }      from './add-document/add-document.module';
import { MASTER_DOC_LIST_MODULE }   from './master-doc-list/master-doc-list.module';
import { ASSESSMENT_REPORTS_MODULE }from './assessment-reports/assessment-reports.module';
import { IMPROVEMENT_MODULE }       from './improvement-actions/improvement.module';

import { accDashboardLocationYear}  from './dashboard/acc-location-year.component';
import { addRegulatoryFramework }   from './add-scheme/add-scheme.component';

export const ACCREDITATION_MODULE = angular.module(
    'migration.accreditation',
    [
        // 'ui.tree',
        'TreeWidget',
        AUDIT_MODULE.name,
        TASKS_MODULE.name,
        REQUIREMENTS_ASSESSMENT_MODULE.name,
        SETTINGS_MODULE.name,
        ADD_DOCUMENT_MODULE.name,
        MASTER_DOC_LIST_MODULE.name,
        ASSESSMENT_REPORTS_MODULE.name,
        IMPROVEMENT_MODULE.name,
    ]
).config(['$uiRouterProvider', ({ stateRegistry }) => {
    Object.values(STATES).map(state => stateRegistry.register(state))
}]).component({
    accDashboardLocationYear,
    addRegulatoryFramework,
}).run(['$templateCache', ({ put }) => {
    put('app.accreditation.add-scheme', '<add-scheme></add-scheme>');
}]);
